import { mergeClasses, t } from "@twire/utility/helpers";
import TournamentNav from "../TournamentsNav";
import Articles from "@twire/common/Articles";
import TournamentsTemplate from "../../TournamentsTemplate";
import TournamentsFilter from "../../TournamentsFilter";
import classes from "./TournamentsView.module.scss";
import FantasyBanner from "@twire/common/FantasyBanner";
import FantasyTournaments from "@twire/common/FantasyTournaments";
import { TournamentsViewProps } from ".";

const TournamentsView: React.FC<TournamentsViewProps> = ({
  type,
  mode = "tournament",
  pptType
}) => {
  const displayNavbar = ['tournament', 'ppt'].includes(mode);
  return (
    <div className={mergeClasses(classes.container, "appear")}>
      <div className={classes.left}>
        {displayNavbar && <TournamentNav mode={mode}/>}
        <div className="mt-6">
          <div className="flex text-twire-light font-bold items-center">
            <span className="mr-3 text-xl">{t("words.filters")}</span>
            <TournamentsFilter type={type} mode={mode} pptType={pptType}/>
          </div>
          <TournamentsTemplate
            type={type}
            infinite
            mode={mode}
            pptType={pptType}
          />
        </div>
      </div>
      <div className={classes.right}>
        <div className="mb-4">
          <FantasyBanner />
        </div>
        <FantasyTournaments />
        <Articles config={{ visibleCount: 3 }} />
      </div>
    </div>
  );
};

export default TournamentsView;
